import { CancerFocus } from '@/services/getCancerTypesV2';

export function getCancerFocusId(
  shortLabel: string | undefined,
  cancerFocuses: CancerFocus[] | undefined
): number | undefined {
  if (!shortLabel || !cancerFocuses) {
    return undefined;
  }

  const focus = cancerFocuses.find((f) => f.shortLabel === shortLabel);

  if (focus?.id === null || focus?.id === undefined) {
    return undefined;
  }

  return Number(focus.id);
}
